export { default } from './BorrowersNames';
